var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Corona"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_7624_61611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5617 8.34598L20.9623 12.0892L16.1836 2.93965C16.0607 2.704 15.844 2.58594 15.6265 2.58594C15.4094 2.58594 15.1919 2.704 15.0686 2.93965L10.2899 12.0892L5.69052 8.34598C5.20627 7.95199 4.53662 8.44437 4.68476 9.08338L6.44024 16.6401L7.60228 17.4051L6.7665 18.0455L7.29657 20.3271C7.36893 20.6381 7.6254 20.8565 7.91912 20.8565H23.3331C23.6268 20.8565 23.8833 20.6381 23.9556 20.3271L24.4857 18.0455L23.9753 17.3428L24.8119 16.6401L26.5674 9.08338C26.716 8.44296 26.0451 7.95292 25.5617 8.34598Z",
    fill: "#FFD734"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.1955 9.04139L24.4684 16.7865L23.7167 17.4152L24.1752 18.0438L23.699 20.0846C23.634 20.3629 23.4036 20.5582 23.1397 20.5582L17.4129 21.2926C17.4129 21.2926 15.8538 21.2926 13.905 20.9028C14.8131 21.3058 19.5584 19.0009 19.0328 18.0438C19.3807 17.3905 10.9274 17.8949 11.2588 17.1653C14.4033 16.7865 15.0946 13.9963 15.3205 13.2184C16.2993 9.84727 16.2158 4.21484 16.2158 4.21484C16.4112 4.21484 16.6059 4.32045 16.7163 4.53124L21.0097 12.7157L25.6714 8.70687C26.1057 8.35527 26.3289 8.46852 26.1955 9.04139Z",
    fill: "#FFC127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M21.8708 17.4685L20.5919 17.2858C22.9481 16.0591 23.7861 13.8368 24.4287 9.67387L26.0731 8.42578L24.4287 16.3723L23.6979 17.4685L24.0633 18.1993L23.3325 20.5745L18.9719 21.1856C20.6699 20.536 21.7365 19.2601 21.8708 17.4685Z",
    fill: "#DD800F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5303 2.65607C14.7575 2.22202 15.1812 1.97656 15.6264 1.97656C16.0725 1.97656 16.4954 2.22246 16.7219 2.65649L21.1561 11.1463L25.1783 7.87275C25.6582 7.4826 26.2536 7.53735 26.6602 7.83505C27.0589 8.12687 27.2903 8.65303 27.1591 9.21872L25.4035 16.7756C25.3738 16.9037 25.3032 17.0187 25.2025 17.1033L24.7993 17.4419L24.9771 17.6866C25.0806 17.8291 25.1171 18.0095 25.0773 18.1811L24.5472 20.4626C24.4189 21.0141 23.9433 21.462 23.333 21.462C18.4183 22.1404 12.7039 22.1558 7.91903 21.462C7.30872 21.462 6.83312 21.0143 6.70483 20.4628L6.17473 18.1811C6.12077 17.9488 6.20768 17.7065 6.39695 17.5614L6.55452 17.4407L6.10612 17.1455C5.97597 17.0598 5.88372 16.9274 5.84846 16.7756L4.09292 9.21863C3.96196 8.65374 4.19311 8.12772 4.59096 7.83568C4.99754 7.53725 5.59329 7.48192 6.07379 7.87286L10.0959 11.1463L14.5301 2.65649L14.5303 2.65607ZM15.6067 3.21934L15.6069 3.21892C15.6132 3.20704 15.6187 3.20025 15.6219 3.19676C15.6238 3.19481 15.6252 3.19351 15.6263 3.19267C15.6272 3.19343 15.6284 3.19452 15.6298 3.19604C15.6329 3.19947 15.6385 3.20634 15.6449 3.21857L20.4238 12.3685C20.5083 12.5302 20.661 12.6454 20.8397 12.6822C21.0184 12.719 21.2041 12.6736 21.3456 12.5584L25.9438 8.81618C25.9543 8.82425 25.966 8.83817 25.9733 8.85736C25.9798 8.87444 25.9854 8.90195 25.9756 8.94417L24.266 16.3033L23.5845 16.8757C23.3404 17.0808 23.2963 17.4398 23.4837 17.6978L23.8312 18.1762L23.3639 20.1875C23.3565 20.2193 23.3421 20.2366 23.3337 20.2438C23.3318 20.2454 23.3303 20.2465 23.3293 20.2471C18.4837 21.0625 12.7683 21.0552 7.9227 20.2471C7.92171 20.2465 7.92024 20.2454 7.91831 20.2438C7.90991 20.2366 7.8955 20.2193 7.88811 20.1875L7.4467 18.2876L7.97164 17.8853C8.12773 17.7657 8.21627 17.578 8.20923 17.3814C8.20219 17.1849 8.10045 17.004 7.9362 16.8958L6.9769 16.2643L5.27641 8.94426C5.26678 8.9026 5.27219 8.87499 5.2788 8.85763C5.28613 8.83842 5.29777 8.82441 5.30828 8.81622L9.90635 12.5584C10.0479 12.6736 10.2336 12.719 10.4123 12.6822C10.591 12.6454 10.7437 12.5302 10.8282 12.3685L15.6067 3.21934ZM25.945 8.81517C25.9501 8.81105 25.9533 8.80914 25.9546 8.80846C25.9556 8.80793 25.9554 8.80815 25.9539 8.80867C25.9509 8.80976 25.9463 8.8107 25.9414 8.8108L25.5616 8.34405",
    fill: "#FFAA16"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55626 10.8742C6.80644 10.8177 7.05119 10.9562 7.10292 11.1836L8.09113 15.3195C8.14286 15.5469 7.98199 15.7771 7.73181 15.8336C7.48164 15.8901 7.23689 15.7515 7.18516 15.5241L6.19695 11.3882C6.14522 11.1608 6.30609 10.9307 6.55626 10.8742Z",
    fill: "#FFF2B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1703",
    d: "M7.84351 19.4379C7.86346 19.1745 8.09662 18.9774 8.36428 18.9977L11.4605 19.2322C11.7282 19.2525 11.929 19.4825 11.909 19.7459C11.8891 20.0093 11.6559 20.2063 11.3883 20.1861L8.29202 19.9515C8.02436 19.9312 7.82355 19.7012 7.84351 19.4379Z",
    fill: "#FFF2B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0665 4.81287C16.3128 4.94211 16.4237 5.21693 16.3142 5.4267L12.5303 12.6778C12.4209 12.8875 12.1325 12.9528 11.8862 12.8236C11.6399 12.6944 11.529 12.4195 11.6385 12.2098L15.4224 4.9587C15.5319 4.74893 15.8203 4.68364 16.0665 4.81287Z",
    fill: "#FFF2B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7624_61611",
    x: 0.194083,
    y: 0.0455281,
    width: 30.8638,
    height: 27.7241,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.93103
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.93103
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7624_61611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7624_61611",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownNew);
export default __webpack_public_path__ + "static/media/crown_new.0726d14c96fb80eb91bee337f8c0dbd7.svg";
export { ForwardRef as ReactComponent };